<template>
  <div>
    <Landing />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Landing from "@/packages/public/components/Landing";
export default {
  name: "",
  components: { Landing },
  data: () => ({}),
  computed: {
    ...mapGetters({
      loading: "loading/is_loading",
    }),
  },
};
</script>
<style scoped></style>
